module.exports = __webpack_public_path__ + "static/media/volumeDreno.dc26844d.jpg";